module.exports = __webpack_public_path__ + "img/title_1.2b64adf7.png";